// client/src/components/SortableHeader.js
import React from "react";

const SortableHeader = ({ label, sortKey, sortConfig, setSortConfig }) => {
    const handleSort = () => {
        if (sortConfig?.key === sortKey) {
        setSortConfig({
            key: sortKey,
            direction: sortConfig.direction === "asc" ? "desc" : "asc",
        });
        } else {
        setSortConfig({ key: sortKey, direction: "asc" });
        }
    };

    const getArrow = () => {
        if (!sortConfig || sortConfig.key !== sortKey) return "↕️";
        return sortConfig.direction === "asc" ? "▲" : "▼";
    };

    return (
        <th
        className="px-4 py-2 cursor-pointer select-none hover:text-blue-600"
        onClick={handleSort}
        >
        <div className="flex items-center gap-1 whitespace-nowrap">
            <span>{label}</span>
            <span className="text-xs">{getArrow()}</span>
        </div>
        </th>
    );
};

export default SortableHeader;
